import React from 'react';
import { useLazyQuery } from '@apollo/client';
import { RecommendationSliders } from '@xp-utilities/web';
import RecommendationsWrapper from './RecommendationsWrapper';
import { handleOnRecommendedProductClick } from './helpers';
import {
  RecommendationSlidersContainerPropTypes,
  RecommendationSlidersContainerDefaultProps,
} from './props';
import { QUICKVIEW_FLAG_QUERY } from './operations';

export default function RecommendationSlidersContainer({
  clientId,
  placements,
  useGrid,
  queryOptions,
}) {
  const [fetchQuickviewFlag] = useLazyQuery(QUICKVIEW_FLAG_QUERY, {
    context: { batch: true },
    fetchPolicy: 'cache-and-network',
  });

  const onRecommendedProductClick = async (...args) => {
    try {
      const { data } = await fetchQuickviewFlag();
      const { isNewQuickviewEnabled = false } = data || {};
      handleOnRecommendedProductClick(isNewQuickviewEnabled, ...args);
    } catch (error) {
      // Fallback to legacy quickview if flag fetch fails
      handleOnRecommendedProductClick(false, ...args);
    }
  };

  return (
    <RecommendationsWrapper clientId={clientId}>
      <RecommendationSliders
        placements={placements}
        onProductClick={onRecommendedProductClick}
        useGrid={useGrid}
        queryOptions={queryOptions}
      />
    </RecommendationsWrapper>
  );
}

RecommendationSlidersContainer.propTypes = RecommendationSlidersContainerPropTypes;
RecommendationSlidersContainer.defaultProps = RecommendationSlidersContainerDefaultProps;
